module.exports = __webpack_public_path__ + "img/合规风险类.072b79cc.png";